import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Rx";
import { Injectable } from "@angular/core";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {

    }

    canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if(localStorage.getItem('token')){
          
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/auth.guard.ts